import TextDocument, {
  Title,
  Paragraph,
  Link,
  Footnote,
  Header,
} from '../../../components/common/TextDocument';

function PrivacyPolicy() {
  return (
    <TextDocument>
      <Title>プライバシーポリシー</Title>
      <Paragraph>{`丸紅フォレストリンクス株式会社（以下「当社」といいます。）は、当社の提供する資源循環プラットフォームサービス「ぼくらの配車さん」で取得した利⽤者の個⼈情報を以下の個⼈情報保護⽅針にしたがって取り扱います。`}</Paragraph>
      <Header>第 1 条（個⼈情報）</Header>
      <Paragraph>{`「個⼈情報」とは、個⼈情報の保護に関する法律（平成⼗五年法律第五⼗七号、以下「個⼈情報保護法」といいます。）にいう「個⼈情報」を指し、⽣存する個⼈に関する情報であって、当該情報に含まれる⽒名、⽣年⽉⽇その他の記述等により特定の個⼈を識別できるもの⼜は個⼈識別符号が含まれるものを指します。`}</Paragraph>
      <Header>第 2 条（個⼈情報の取得と利⽤）</Header>
      <Paragraph>{`当社は、以下の⽬的に必要な範囲で、ご本⼈の個⼈情報を取得し、取得した情報を利⽤させていただきます。なお、以下の⽬的の範囲を超えて個⼈情報を利⽤する場合には、事前に適切な⽅法でご本⼈からの同意を得るものとします。
(1) 当社のサービス（以下「本サービス」といいます。）を提供するため
(2) 本サービスに関する登録、本⼈確認、利⽤者認証、利⽤者設定の記録、及び本サービスの提供、維持、保護のため
(3) サービスの内容を改良・改善し、⼜は新サービスを開発するため
(4) 本サービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスのご案内（電⼦メール、チラシ、その他のダイレクトメールの送付を含む）のため
(5) メンテナンス、重要なお知らせなど必要に応じたご連絡のため
(6) 本サービスに関する利⽤者からのお問い合わせに回答するため（本⼈確認を⾏うことを含む）
(7) 本サービスの利⽤状況を利⽤者にご報告するため
(8) 本サービスに関するアンケート・取材等のご協⼒依頼や各種イベントへのご参加をお願いし、⼜はその結果などをご報告するため
(9) 本サービスの利⽤履歴等を調査・分析し、その結果を本サービスの改良・開発や広告の配信に利⽤するため
(10) 利⽤規約に違反した利⽤者や、不正・不当な⽬的で本サービスを利⽤しようとする利⽤者の特定をし、ご利⽤をお断りするため
(11) 本サービスに関する規約等の変更などを通知するため`}</Paragraph>
      <Header>第 3 条（個⼈情報の管理と保護）</Header>
      <Paragraph>{`個⼈情報の管理は、厳重に⾏うこととし、次に掲げる場合を除き、ご本⼈の同意がない限り、第三者に対しデータを開⽰・提供することはいたしません。 また、安全性を考慮し、個⼈情報への不正アクセス、個⼈情報の紛失、破壊、改ざん及び漏えい等のリスクに対する予防並びに是正に関する対策を講じます。
(1) ⼈の⽣命、⾝体⼜は財産の保護のために必要がある場合であって、本⼈の同意を得ることが困難である場合
(2) 公衆衛⽣の向上⼜は児童の健全な育成の推進のために特に必要がある場合であって、本⼈の同意を得ることが困難である場合
(3) 国の機関若しくは地⽅公共団体⼜はその委託を受けた者が法令の定める事務を遂⾏することに対して協⼒する必要がある場合であって、本⼈の同意を得ることにより当該事務の遂⾏に⽀障を及ぼすおそれがある場合
(4) 業務を円滑に遂⾏するため、利⽤⽬的の達成に必要な範囲内において個⼈情報の取扱いの全部⼜は⼀部を委託する場合
(5) 合併その他の事由による事業の承継に伴って個⼈情報が提供される場合
(6) 個⼈情報を特定の者との間で共同して利⽤する場合であって、その旨並びに共同して
利⽤される個⼈情報の項⽬、共同して利⽤する者の範囲、利⽤する者の利⽤⽬的及び当該個⼈情報の管理について責任を有する者の⽒名⼜は名称について、あらかじめ本⼈に通知し、⼜は本⼈が容易に知り得る状態に置いた場合
(7) その他法令で認められる場合`}</Paragraph>
      <Header>第 4 条（個⼈情報の取扱いの委託）</Header>
      <Paragraph>{`当社は、利⽤⽬的の達成に必要な範囲内において、個⼈情報の取扱いの全部⼜は⼀部を委託する場合がございます。この場合、当社は、委託先としての適格性を⼗分審査するとともに、契約にあたって守秘義務に関する事項等を定め、委託先に対する必要かつ適切な監督を⾏います。また、当社は、取得個⼈情報の全部⼜は⼀部を、個⼈情報保護法の定めに基づいて共同利⽤することがございます。`}</Paragraph>
      <Header>第 5 条（個人情報の開示）</Header>
      <Paragraph>{`当社は、利⽤者から個⼈情報の開⽰を求められたときは、利⽤者に対し、遅滞なくこれを開⽰します。但し、開⽰することにより次のいずれかに該当する場合は、その全部⼜は⼀部を開⽰しないこともあり、開⽰しない決定をした場合には、その旨を遅滞なく通知します。
(1) 利⽤者⼜は第三者の⽣命、⾝体、財産その他の権利利益を害するおそれがある場合
(2) 当社の業務の適正な実施に著しい⽀障を及ぼすおそれがある場合
(3) その他法令に違反することとなる場合`}</Paragraph>
      <Header>第 6 条（個⼈情報の訂正及び削除）</Header>
      <Paragraph>{`(1) 当社の保有する個⼈情報が誤った情報である場合には、利⽤者の請求により、当社が定める⼿続きに従い個⼈情報の訂正⼜は削除を⾏います。
(2) 当社は、利⽤者から前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個⼈情報の訂正⼜は削除を⾏い、これを利⽤者に通知します。`}</Paragraph>
      <Header>第 7 条（個⼈情報の利⽤停⽌等）</Header>
      <Paragraph>{`当社は、利⽤者から、個⼈情報が、利⽤⽬的の範囲を超えて取り扱われているという理由、⼜は不正の⼿段により取得されたものであるという理由により、その利⽤の停⽌⼜は消去（以下「利⽤停⽌等」といいます。）を求められた場合には、遅滞なく必要な調査を⾏い、その結果に基づき、個⼈情報の利⽤停⽌等を⾏い、その旨利⽤者に通知します。但し、個⼈情報の利⽤停⽌等に多額の費⽤を有する場合その他利⽤停⽌等を⾏うことが困難な場合であって、利⽤者の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じます。`}</Paragraph>
      <Header>第 8 条 (Cookie等の利⽤等について)</Header>
      <Paragraph>{`本サービスでは、ご利⽤者により適切なサービスをご提供するため、クッキー（Cookie）、ウェブビーコン（web beacon）、その他のトラッキング⼜は解析を⾏うための類似技術（以下総称して「Cookie」といいます。）を使⽤しています。
Cookie は、利⽤者が本サービスをウェブサイトで閲覧した際に、ウェブサーバと利⽤者のインターネット閲覧ソフト（ブラウザ）との間でやりとりされ、利⽤者の端末に保存されるものです。当社は、これを利⽤することにより、ご利⽤者の閲覧履歴、サービス利⽤履歴等、それ⾃体では個⼈が特定できない属性情報を取得することがあります。
ご利⽤者は、ブラウザの設定により、事前に、Cookie を使⽤しているサイトであることを表⽰したり、Cookie の無効化及び保存済みのCookie の削除をしたりすることができます。Cookie の利⽤を拒否し⼜はCookie を削除した場合、ウェブサイトでご利⽤いただくことができる機能が制限される可能性がありますのでご了承ください。`}</Paragraph>
      <Header>第 9 条 （他社モジュールの利⽤について）</Header>
      <Paragraph>
        {`本サービスでは、本サービスの利⽤状況の把握及び広告配信等の⽬的で他社モジュールを設置しています。設置しているモジュールは以下のとおりです。当社は、以下の提供会社が当社⼜は当該提供会社の設定するCookieを使⽤し、本サービスの利⽤状況に関する情報等を収集・処理・分析した結果を受け取り、ご利⽤者の利⽤状況の把握・分析やそれらに基づく当社のサービスの提供のために利⽤する場合があります。当該提供会社による以下のモジュールにおけるデータの取扱いについては、同社の以下のサイトをご覧ください。

・Googleアナリティクス
提供会社 ： Google Inc.
取得項⽬ ： `}
        <Link>https://policies.google.com/privacy?hl=ja</Link>
        {`
提供会社のプライバシーポリシー等 ： `}
        <Link>https://policies.google.com/privacy?hl=ja</Link>
        {`
Google アナリティクスでデータが収集・処理される仕組みについて ： `}
        <Link>
          https://policies.google.com/technologies/partner-sites?hl=ja
        </Link>
        {`
オプトアウトの⽅法 ： `}
        <Link>https://tools.google.com/dlpage/gaoptout?hl=ja</Link>
      </Paragraph>
      <Header>第 10 条（プライバシーポリシーの変更⼿続）</Header>
      <Paragraph>{`当社は本ポリシーの内容を適宜⾒直し、その改善に努めます。本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、変更することができるものとします。変更後のプライバシーポリシーは、当社所定の⽅法により、利⽤者に通知し、⼜は当社ウェブサイトに掲載したときから効⼒を⽣じるものとします。`}</Paragraph>
      <Header>第 11 条（法令、規範の遵守）</Header>
      <Paragraph>{`当社は、保有する個⼈情報に関して適⽤される⽇本の法令、その他規範を遵守します。`}</Paragraph>
      <Header>第 12 条（苦情及び相談への対応）</Header>
      <Paragraph>{`当社は、個⼈情報の取扱いに関する利⽤者からの苦情、相談を受け付け、適切かつ迅速に対応いたします。また、利⽤者からの当該個⼈情報の開⽰、訂正、追加、削除、利⽤⼜は提供の拒否などのご要望に対しても、迅速かつ適切に対応いたします。`}</Paragraph>
      <Header>第 13 条（お問い合わせ窓⼝）</Header>
      <Paragraph>{`当社の個⼈情報の取扱に関するお問い合せは下記までご連絡ください。
丸紅フォレストリンクス株式会社 個⼈情報取扱窓⼝

Mail: contact-haisyasan@marubeni-flx.com`}</Paragraph>
      <Footnote>2024年2月1日制定・施⾏</Footnote>
    </TextDocument>
  );
}

export default PrivacyPolicy;
